import { render, staticRenderFns } from "./AllPermissions.vue?vue&type=template&id=fd02b9b8&scoped=true&"
import script from "./AllPermissions.vue?vue&type=script&lang=js&"
export * from "./AllPermissions.vue?vue&type=script&lang=js&"
import style0 from "./AllPermissions.vue?vue&type=style&index=0&id=fd02b9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd02b9b8",
  null
  
)

export default component.exports